import styled from "styled-components";
import { spacing, color } from "@conserveit/blocks";

export const Wrapper = styled.div`
  position: relative;

  .Wrapper-inner {
    max-width: 568px;
    margin: auto;
    padding: ${spacing.ultraLoose};
  }
`;

export const Footer = styled.div`
  display: flex;
  margin-top: ${spacing.snug};
  align-items: center;
`;

Footer.Section = styled.div`
  flex-basis: calc(100% / 3);
`;

Footer.Help = styled(Footer.Section)`
  text-align: center;
`;

export const FooterLink = styled.a`
  display: inline-block;
  color: ${color.theme.typography.ink};

  &:hover {
    color: ${color.theme.typography.ink};
    text-decoration: underline;
  }
`;
